import classNames from 'classnames/bind';
import React from 'react';
import { MdOutlineSportsEsports, MdOutlineRemoveRedEye, MdOutlinePushPin } from 'react-icons/md';
import { useSelector } from 'react-redux';

import styles from './Top.module.scss';

import MavLinkLogo from '@/assets/images/logo-mavlink.png';

const cx = classNames.bind(styles);

const Top = ({ owned, robotId, children }) => {
  const focusRobotId = useSelector((state) => state.robot.focusRobotId);

  return (
    <div className={cx('container')}>
      <div className={cx(['side', 'left'])}>
        <div className={cx('mavlinkLogo')}>
          <img src={MavLinkLogo} alt="MavLink" />
        </div>
        {owned && <MdOutlineSportsEsports size={16} color="white" />}
        {!owned && <MdOutlineRemoveRedEye size={16} color="white" />}
        {focusRobotId === robotId && (
          <MdOutlinePushPin size={16} color="white" style={{ transform: 'rotate(30deg)' }} />
        )}
      </div>
      <div className={cx('side')}>{Array.isArray(children) ? children : [children]}</div>
    </div>
  );
};

export default Top;
